/**
 * Created by han on 1/18/2019.
 */

import $ from '../../util/dom';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock/lib/bodyScrollLock.es6';

/*
*
* event:
* 	endPreloadAnimation - finish animation + 300ms
*
* */

export default function PreloadAnimation(context) {
	const screenLock_elem = $('[data-preload]');
	// const content_elem = screenLock_elem.children();

	disableBodyScroll( screenLock_elem );

    screenLock_elem.animate({
        opacity: 0
    }, {
        duration: 1200,
        complete: () => {
            setTimeout(() => {
                // context.emit('endPreloadAnimation');
            }, 300);
            screenLock_elem.css('visibility', 'hidden');
            enableBodyScroll( screenLock_elem );
        },
    });
};